import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const MaskLine = ({ children, delay = 0, className = "" }) => (
  <span className="block overflow-hidden pb-[0.06em]">
    <motion.span
      className={`block ${className}`}
      initial={{ y: "108%" }}
      animate={{ y: 0 }}
      transition={{ duration: 1.15, ease: EASE, delay }}
    >
      {children}
    </motion.span>
  </span>
);

export const Reveal = ({ children, delay = 0, className = "", y = 28, ...rest }) => (
  <motion.div
    {...rest}
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.12 }}
    transition={{ duration: 0.85, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ index, eyebrow, title, light = false, className = "" }) => (
  <Reveal className={`max-w-3xl ${className}`}>
    <p className={`font-mono text-xs uppercase tracking-[0.25em] ${light ? "text-[#8A6A2C]" : "text-[var(--gold)]"}`}>
      {index && <span className="mr-3 opacity-80">{index} —</span>}
      {eyebrow}
    </p>
    <h2 className={`font-display mt-4 text-4xl sm:text-5xl lg:text-6xl font-extrabold uppercase leading-[0.95] ${light ? "text-[var(--navy)]" : "text-white"}`}>
      {title}
    </h2>
  </Reveal>
);
